import { useEffect, useRef, useState } from 'react';
import './index.css';

function AutoComplete({
    classInput = '',
    label= '',
    placeholder = '',
    required = false,
    disabled = false,
    value,
    isError = false,
    onChange,
    onBlur,
    autoComplete = [],
    onClick
}){
  const [focus, setFocus] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setFocus(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref]);

  return (
    <>
      <div className={classInput + ' pt-4'} ref={ref}>
        <div className="row">
        <label className='form_label' htmlFor="">{label} {required == true && <span style={{color: 'red'}}>*</span> }</label>
        <input 
          className= {isError ? 'form_input col-12 is_error' : 'form_input col-12 '}
          type="text"
          placeholder={placeholder}
          disabled={disabled ? 'disabled' : ''}
          value={value}
          onChange={(e) => {
            onChange(e);
            setFocus(true);
          }}
          onBlur={onBlur}
          onFocus={() => setFocus(true)}
        />
        {autoComplete.length > 0 && focus && 
          <>
            <div className="autoComplete" >
              {autoComplete.map((e, index) => {
                return(
                  <div key={index} className="e_autoComplete" onClick={async ()=>{
                    await onClick(index);
                    setFocus(false);
                  }}>{e}</div>
                );
              })}
            </div>
          </>
        }
        </div>
      </div>
    </>
  );
}
export default AutoComplete;